/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tap[_ngcontent-%COMP%]{width:100%;height:auto}.tap--path[_ngcontent-%COMP%]{fill:var(--color-primary)}ocm-screen-saver[_nghost-%COMP%]   .tap--path[_ngcontent-%COMP%], ocm-screen-saver   [_nghost-%COMP%]   .tap--path[_ngcontent-%COMP%]{fill:#fff}"];
export { styles as styles };
